import { reqAPI } from "../utils/fetch-request";

export async function getUserManagementList(params = {}) {
  return reqAPI(`api/merchant/user-management`, params);
}

export async function getUserManagementRoles() {
  return reqAPI(`api/merchant/user-management/get-roles`);
}

export async function getUserManagementDetail(id) {
  return reqAPI(`api/merchant/user-management/${id}`);
}

export async function getUserManagementHistories(id) {
  return reqAPI(`api/merchant/user-management/${id}`);
}

export async function getUserManagementLogActivities(id, params = {}) {
  return reqAPI(`api/merchant/user-management/${id}/activity-log`, params);
}

export async function createUser(payload) {
  return reqAPI(`api/merchant/user-management`, payload, "POST");
}

export async function updateUser(id, payload) {
  return reqAPI(`api/merchant/user-management/${id}`, payload, "PATCH");
}

export async function reactiveUser(id) {
  return reqAPI(`api/merchant/user-management/${id}/reactive`, {}, "PATCH");
}

export async function suspendUser(id) {
  return reqAPI(`api/merchant/user-management/${id}/suspend`, {}, "PATCH");
}

export async function resendEmail(id) {
  return reqAPI(`api/merchant/user-management/${id}/resend-email`, {}, "POST");
}
